import axios from '@/libs/api.request';
import search from '@/libs/search';
import axiosRequest from 'axios';

import { getMainCategoryList, getSubCategoryList } from '@/api/modules/product-management/category-management';
import { getBrandList } from '@/api/modules/product-management/brand-management';
import { getSerialList } from '@/api/modules/product-management/serial-management';
import { getUnitList } from '@/api/modules/system-management/unit-management';
import { getPackageList } from '@/api/modules/system-management/package-management';
import { webGetAllRegion } from '@/api/modules/system-management/region-management';
import { getSeedFarmCode } from '@/api/modules/system-management/seedFarm-management';
import { getMasterUserList } from '@/api/modules/account-management/master-user-management';

export const getProductList = data => {
    return axios.request({
        url: 'api/productManagement/product/getProductList',
        data: data,
        method: 'post'
    });
};

export const updateProductForShow = data => {
    return axios.request({
        url: 'api/productManagement/product/updateProductForShow',
        data: data,
        method: 'post'
    });
};

export const deleteProductByUuid = data => {
    return axios.request({
        url: 'api/productManagement/product/deleteProductByUuid',
        data: data,
        method: 'post'
    });
};

export const getAgentProductList = data => {
    return axios.request({
        url: 'api/productManagement/product/getAgentProductList',
        data: data,
        method: 'post'
    });
};

export const deleteProduct = productUuid => {
    return axios.request({
        url: 'api/productManagement/product/deleteProduct',
        data: { productUuid },
        method: 'post'
    });
};

export const saveProduct = data => {
    return axios.request({
        url: 'api/productManagement/product/saveProduct',
        data: data,
        method: 'post'
    });
};


export const saveProductList = data => {
    return axios.request({
        url: 'api/productManagement/product/saveProductListBaseInformation',
        data: data,
        method: 'post'
    });
};

export const setProductTop = data => {
    return axios.request({
        url: 'api/productManagement/product/setProductTop',
        data: data,
        method: 'post'
    });
};

export const getProductDetail = productUuid => {
    return axios.request({
        url: 'api/productManagement/product/getProductDetail',
        data: { productUuid },
        method: 'post'
    });
};

export const pageInit4ProductEdit = () => {
    const searchCondition = search.getSearchParams({ closeAllConditions: true });

    return axiosRequest.all([
        getMainCategoryList(searchCondition),
        getSubCategoryList(searchCondition),
        getBrandList(searchCondition),
        getSerialList(searchCondition),
        getUnitList(searchCondition),
        getPackageList(searchCondition),
        webGetAllRegion({}),
        getSeedFarmCode(),
        getMasterUserList(searchCondition)
    ]).then(axiosRequest.spread(function (mainCategories, subCategories, brands, serials, units, packages, allRegions, seedFarmCode, masters) {
        if (mainCategories.code === 0
            && subCategories.code === 0
            && brands.code === 0
            && serials.code === 0
            && units.code === 0
            && packages.code === 0
            && allRegions.code === 0
            && masters.code === 0
            && seedFarmCode.code === 0) {
            return {
                code: 0,
                message: '',
                data: {
                    mainCategories: mainCategories.data,
                    subCategories: subCategories.data,
                    brands: brands.data,
                    serials: serials.data,
                    units: units.data,
                    packages: packages.data,
                    allRegions: allRegions.data.allRegions,
                    seedFarmCode: seedFarmCode.data.seedFarmCode,
                    masters: masters.data
                }
            };
        }
    }));
};

export const getProductBlockDist = data => {
    return axios.request({
        url: 'api/productManagement/blockDist/getProductBlockDist',
        data: data,
        method: 'post'
    });
};

export const saveProductBlockDist = data => {
    return axios.request({
        url: 'api/productManagement/blockDist/saveProductBlockDist',
        data: data,
        method: 'post'
    });
};

export const getProductPrivateCustomer = data => {
    return axios.request({
        url: 'api/productManagement/privateSale/getProductPrivateCustomer',
        data: data,
        method: 'post'
    });
};

export const updateProductPrivateSale = data => {
    return axios.request({
        url: 'api/productManagement/privateSale/updateProductPrivateSale',
        data: data,
        method: 'post'
    });
};

export const updateProductDisplayOrder = data => {
    return axios.request({
        url: 'api/productManagement/product/updateProductDisplayOrder',
        data: data,
        method: 'post'
    });
};

export const getProductSpecialCommission = data => {
    return axios.request({
        url: 'api/productManagement/specialCommission/getProductSpecialCommission',
        data: data,
        method: 'post'
    });
};


export const saveProductSpecialCommission = data => {
    return axios.request({
        url: 'api/productManagement/specialCommission/saveProductSpecialCommission',
        data: data,
        method: 'post'
    });
};

export const qiniuToken = data => {
    return axios.request({
        url: 'api/qiniu/token',
        data: data,
        method: 'post'
    });
};

export const syncYsProduct = data => {
    return axios.request({
        url: 'api/productManagement/YS/syncYsProduct',
        data: data,
        method: 'post'
    });
};
